import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface ConfirmTransplantationDialogData {
  recipientName: string;
  donorName: string;
  recipientEnis: string;
  donorEnis: string;
}

export interface ConfirmTransplantationDialogResult {
  confirmed: boolean;
}

@Component({
  selector: 'app-confirm-transplantation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Confirm Transplantation</h2>
    <mat-dialog-content>
      <p>
        Are you sure you want to confirm the transplantation for this chain link?
      </p>
      <div class="pair-info">
        <div class="participant-row">
          <strong>Recipient:</strong> {{ data.recipientName }} ({{ data.recipientEnis }})
        </div>
        <div class="participant-row">
          <strong>Donor:</strong> {{ data.donorName }} ({{ data.donorEnis }})
        </div>
      </div>
      <p class="info-note">
        Both participants will be marked as <strong>transplanted</strong>. If they are part of an original pair and both members are now transplanted, the pair will be automatically set to historical.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">
        Confirm Transplantation
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      max-width: 600px;
      min-width: 500px;
      padding: 20px 24px;
    }
    mat-dialog-content p {
      margin-bottom: 16px;
      line-height: 1.5;
    }
    .pair-info {
      background-color: #f5f5f5;
      border-left: 4px solid #1976d2;
      padding: 12px 16px;
      margin: 16px 0;
      border-radius: 4px;
    }
    .participant-row {
      margin-bottom: 8px;
      font-size: 14px;
    }
    .participant-row:last-child {
      margin-bottom: 0;
    }
    .info-note {
      color: #666;
      font-size: 14px;
      font-style: italic;
    }
    mat-dialog-actions {
      padding: 16px 24px;
    }
  `]
})
export class ConfirmTransplantationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmTransplantationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmTransplantationDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
